import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {
  FDBox,
  FDClickableText,
  FDIcon,
  FDStack,
} from '@facet-wealth/design';
import Collapse from '@mui/material/Collapse';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('RoadmapDeliverableNavItem', (theme) => ({
  root: {
    '& .FD-MuiLink-underlineAlways, & [role="link"]': {
      textDecoration: 'none',
    },
  },
  disabledRoot: {
    '&, & .FD-MuiLink-underlineAlways, & [role="link"], & .FD-MuiSvgIcon-root': {
      color: theme.palette.facet.oceana700,
    },
  },
}));

export const NavItem = ({
  onClick: onClickProp, href, children, title, expandedByDefault, canExpand, disabled,
}) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(expandedByDefault);
  const onClick = canExpand
    ? () => setExpanded(val => !val)
    : onClickProp;

  let icon = null;
  if (canExpand) {
    icon = <FDIcon icon={expanded ? 'keyboardArrowDown' : 'keyboardArrowUp'} color={disabled ? 'textDisabled' : 'white'} />;
  }

  const label = (
    <FDStack alignItems="center" spacing={1}>
      {title}
      {icon}
    </FDStack>
  );

  return (
    <div className={classNames(classes.root, { [classes.disabledRoot]: disabled })}>
      <FDStack direction="column" flex={1} spacing={0}>{/* Don't add spacing here or else collapsing the children will leave the unecessary spacing */}
        {disabled ? label : (
          <FDClickableText
            onClick={onClick}
            href={href}
            appearance="standalone"
            label={label}
          />
        )}
        {canExpand ? (
          <Collapse in={expanded}>
            <FDBox paddingY={1} />{/* Add spacing with the above component here so that when collapsed, the spacing disappears */}
            <FDStack direction="row" flex={1} spacing={1}>
              <FDBox paddingX={1} />
              <FDStack direction="column" spacing={2}>
                {children}
              </FDStack>
            </FDStack>
          </Collapse>
        ) : null}
      </FDStack>
    </div>
  );
};

NavItem.propTypes = {
  canExpand: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  href: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
  expandedByDefault: PropTypes.bool,
  disabled: PropTypes.bool.isRequired,
};
